import React from 'react';
import { Alert } from 'reactstrap';

import { useToastHost } from '~libs/toast';

// reactstrap gives `Alert` its fade transition through `Fade.defaultProps`, which React no longer
// applies to function components - so `timeout` reaches Fade as undefined and every toast logs a
// failed-prop-type error. Passing the transition explicitly restores the value reactstrap intends
// (its own `Fade` default) rather than suppressing the warning.
const TOAST_TRANSITION = { timeout: 150, unmountOnExit: true };

const ToastHost: React.FC = () => {
  const { toasts, removeToast } = useToastHost();

  if (toasts.length === 0) return null;

  return (
    <div className="position-fixed top-0 end-0 p-3" style={{ zIndex: 1090, minWidth: '280px' }}>
      {toasts.map((t) => (
        <Alert
          key={t.id}
          color={t.type}
          toggle={() => removeToast(t.id)}
          className="mb-2 shadow"
          transition={TOAST_TRANSITION}
        >
          {t.message}
        </Alert>
      ))}
    </div>
  );
};

export default ToastHost;
